import { SVGProps } from './SVGProps';

export const SquareCursor = (props: SVGProps) => {
  return (
    <svg
      width={props.width || '20'}
      height={props.height || '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M2.5 7.08333V4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.08333M2.5 12.9167V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H7.08333M12.9167 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V7.08333M17.3991 14.0976C17.8108 14.3509 17.785 14.9668 17.3616 15.0151L15.2225 15.2576L14.2633 17.1843C14.0733 17.5668 13.4858 17.3793 13.3883 16.906L11.3425 10.8093C11.26 10.4093 11.62 10.1576 11.9675 10.3718L17.3991 14.0976Z"
        stroke={props.color || 'currentColor'}
        strokeWidth={props.strokeWidth || '1.5'}
        strokeLinecap="round"
      />
    </svg>
  );
};
